var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCicleValetFullBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47986 10.2702L5.83341 10.6238L6.18697 10.2702L11.437 5.02024L11.7893 4.66793L11.4382 4.31438L10.6157 3.48605L10.2622 3.13L9.90736 3.4848L5.83292 7.55924L4.09231 5.82347L3.73875 5.47091L3.38569 5.82397L2.56319 6.64647L2.20964 7.00002L2.56319 7.35357L5.47986 10.2702ZM1.66675 7.00002C1.66675 4.05616 4.05622 1.66669 7.00008 1.66669C9.94394 1.66669 12.3334 4.05616 12.3334 7.00002C12.3334 9.94388 9.94394 12.3334 7.00008 12.3334C4.05622 12.3334 1.66675 9.94388 1.66675 7.00002Z",
    fill: "#787E7D",
    stroke: "#787E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCicleValetFullBg);
export default __webpack_public_path__ + "static/media/check-cicle-valet-full-bg.7411ed3d95ded4584710e236a8f8421b.svg";
export { ForwardRef as ReactComponent };